// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39fbv","content":"styles_content__1rZW1","tableWrap":"styles_tableWrap__FYirW"};